import { WSForm, WSInputMask } from "@wingspanhq/fe-component-library";
import React from "react";
import { getSsnInputProps } from "../../../../shared/utils/getSsnInputProps";
import { IDynamicFieldProps } from "../../types";
import { fieldLabel, isFieldRequired } from "../../utils/fieldRules";

/**
 * Renders a `MaskedId` field — a sensitive identifier entered through a masked
 * input (the tax layer uses it for SSN/EIN). The mask comes from
 * `field.ui.mask` when the server provides one; otherwise we fall back to the
 * shared masked-identifier input props (mask + fsExclude + placeholder).
 */
export const DynamicFieldMaskedId: React.FC<IDynamicFieldProps> = ({
  field,
  name,
  disabled,
  defaultValue
}) => {
  const isReadOnly = field.prefill?.editable === false;
  const ssnProps = getSsnInputProps({
    showPlaceholder: true,
    isValueProvided: isReadOnly
  });
  const mask = field.ui?.mask ?? ssnProps.mask;
  return (
    <WSForm.Field
      name={name}
      defaultValue={defaultValue}
      label={fieldLabel(field)}
      description={field.description ?? field.ui?.helpText}
      component={WSInputMask}
      componentProps={{
        ...ssnProps,
        mask,
        placeholder: field.ui?.placeholder ?? ssnProps.placeholder,
        fsExclude: field.ui?.fsExclude ?? ssnProps.fsExclude,
        disabled: disabled || isReadOnly,
        required: isFieldRequired(field)
      }}
    />
  );
};
